import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { usePois } from '../../contexts/PoisContext'
import PoiThumbnail from './PoiThumbnail'

const SameCityPois = ({ poi, acceptedTypes = [], titleKey }) => {
  const { t } = useTranslation()
  const { pois } = usePois()

  const [filteredPois, setFilteredPois] = useState([])

  useEffect(() => {
    if (!pois || !pois.length) return
    if (!poi || !poi.city || !poi.city.name) return
    if (!acceptedTypes.length) return

    const cityName = poi.city.name.toLowerCase()

    const sameCityPois = pois.filter((p) => {
      const poiCity = p.city?.name?.toLowerCase()
      const poiType = p.poiType?.name

      return (
        poiCity === cityName &&
        acceptedTypes.includes(poiType) &&
        p.id !== poi.id // évite d’afficher le POI courant
      )
    })

    setFilteredPois(sameCityPois)
  }, [pois, poi?.city?.name, poi?.id]) // dépendances stables

  if (!filteredPois.length) return null

  return (
    <div className="mt-4">
      <hr />
      <h2 className="mb-4">{t(titleKey)}</h2>

      <div className="row g-4">
        {filteredPois.map((item) => (
          <div className="col-md-6 col-lg-4 d-flex" key={item.id}>
            <PoiThumbnail poi={item} />
          </div>
        ))}
      </div>
    </div>
  )
}

export default SameCityPois
